"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'style.form.title.edit': 'Editar Estilo de Escritura',
    'style.form.title.add': 'Agregar Estilo de Escritura',
    'style.form.back': 'Atrás',
    'style.form.name.label': 'Nombre',
    'style.form.name.placeholder': 'Nombre del estilo',
    'style.form.description.label': 'Descripción',
    'style.form.description.placeholder': 'Describe este estilo de escritura',
    'style.form.prompt.label': 'Prompt del Estilo',
    'style.form.prompt.placeholder': 'Ingresa el prompt de IA que define este estilo de escritura...',
    'style.form.common.label': 'Estilo Común',
    'style.form.common.description': 'Los estilos comunes están disponibles para todos los usuarios pero solo pueden ser editados por super administradores',
    'style.form.active.label': 'Activo',
};
